export const LocalStorageAuthSession = 'AUTH_SESSION'
export const LocalStoragePendingPasskeyStep = 'PASSKEY_PENDING_STEP'

export type AuthStatus = 'unknown' | 'authenticated' | 'unauthenticated'

export type PendingPasskeyStep =
  | 'SET_UP_PASSKEY'
  | 'VERIFY_PASSKEY'
  | 'EXPIRED_PASSKEY'

export interface AuthState {
  accessToken: string
  refreshToken: string
  userId: string
  organizationId: string
  membershipId: string
  status: AuthStatus
  lastExplicitLoginAt: number
  pendingPasskeyStep: PendingPasskeyStep | null
}
